import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Components/Home";
import Fee from "./pages/Fee";
import GeneralSkinHealthAdvice from "./pages/GeneralSkinHealthAdvice";
import TopicalTreatments from "./pages/TopicalTreatments";
import SkinCancerAwareness from "./pages/SkinCancerAwareness";
import CommonSkinDiseases from "./pages/CommonSkinDiseases";
import Prescription from "./pages/Prescription";
import Consultations from "./pages/Consultations";
import Referrals from "./pages/Referrals";
import NonSurgicalProcedures from "./pages/NonSurgicalProcedures";
import SurgicalProcedures from "./pages/SurgicalProcedures";
import GeneralDermatology from "./pages/GeneralDermatology";
import AboutUs from "./pages/AboutUsDetail";
import Locations from "./pages/Contact";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
// import Media from "./pages/Media";
import MediaPublications from "./pages/Media2";
import TestProcedures from "./pages/TestProcedures.js";
// import Paediatric from "./pages/Paediatric";
import { InfinitySpin } from "react-loader-spinner";

const App = () => {
  const [showScrollTopButton, setShowScrollTopButton] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fakeLoading = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    // Clean up the timeout to avoid memory leaks
    return () => clearTimeout(fakeLoading);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      // Check if the user has scrolled down enough to show the button
      const scrollY = window.scrollY;
      const scrollThreshold = 200; // Adjust as needed
      setShowScrollTopButton(scrollY > scrollThreshold);
    };

    // Add scroll event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Remove event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Add smooth scrolling behavior
    });
  };
  return (
    <BrowserRouter>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "white", // Adjust the alpha value for transparency
            zIndex: "5000",
          }}
        >
          <InfinitySpin color="#03b1ed" size={30} />
        </div>
      )}

      {showScrollTopButton && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            background: "#03b1ed",
            color: "white",
            borderRadius: "50%",
            padding: "10px",
            cursor: "pointer",
            zIndex: "5",
          }}
          onClick={scrollToTop}
          title="Scroll to Top"
        >
          <KeyboardArrowUpIcon />
        </div>
      )}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Fee" element={<Fee />} />
        <Route
          path="/GeneralSkinHealthAdvice"
          element={<GeneralSkinHealthAdvice />}
        />
        <Route path="/TopicalTreatments" element={<TopicalTreatments />} />
        <Route path="/SkinCancerAwareness" element={<SkinCancerAwareness />} />
        <Route path="/CommonSkinDiseases" element={<CommonSkinDiseases />} />
        <Route path="/Prescription" element={<Prescription />} />
        <Route path="/Consultations" element={<Consultations />} />
        <Route path="/Referrals" element={<Referrals />} />
        <Route
          path="/NonSurgicalProcedures"
          element={<NonSurgicalProcedures />}
        />
        <Route path="/SurgicalProcedures" element={<SurgicalProcedures />} />
        <Route path="/GeneralDermatology" element={<GeneralDermatology />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/Locations" element={<Locations />} />
        <Route path="/MediaPublications" element={<MediaPublications />} />
        {/* <Route path="/Paediatric" element={<Paediatric />} /> */}
        <Route path="/TestProcedures" element={<TestProcedures />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
